<template>
	<section class="sub_container">
		<div class="search_form">
			<h2>반품현황</h2>
			<div class="contents">
        <div class="row">
          <div class="cell">
            <label class="mb0">구분</label>
            <div class="cell_se_input">
              <a href="javascript:void(0);" @click="clkGubn('gubn_nomal')">
                <span v-bind:class="{dviBtn: true, on: gubnNomal}">일반</span>
              </a>
              <a href="javascript:void(0);" @click="clkGubn('gubn_insurance')">
                <span v-bind:class="{dviBtn: true, on: gubnInsurance}">보험</span>
              </a>
            </div>
          </div>
          <div class="cell">
            <label class="mb0">반품 진행</label>
            <div class="cell_se_input">
              <a href="javascript:void(0);" @click="clkGubn('return_progress_nomal')">
                <span v-bind:class="{dviBtn: true, on: returnProgressNomal}">일반</span>
              </a>
              <a href="javascript:void(0);" @click="clkGubn('return_progress_insurance')">
                <span v-bind:class="{dviBtn: true, on: returnProgressInsurance}">보험</span>
              </a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="cell">
            <label for="" class="mb0">반품 상태</label>
            <div class="cell_se_input">
              <a href="javascript:void(0);" @click="clkGubn('return_status_request')">
                <span v-bind:class="{dviBtn: true, on: returnStatusRequest}">요청</span>
              </a>
              <a href="javascript:void(0);" @click="clkGubn('return_status_confirm')">
                <span v-bind:class="{dviBtn: true, on: returnStatusConfirm}">승인</span>
              </a>
              <a href="javascript:void(0);" @click="clkGubn('return_status_rejection')">
                <span v-bind:class="{dviBtn: true, on: returnStatusRejection}">반려</span>
              </a>
            </div>
          </div>
          <div class="cell">
            <label>주문번호</label>
            <div class="form-group mt10">
              <input type="text" class="input-text w100-p" placeholder="주문번호" v-model="orderId">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="cell">
            <label for="">반품 받을 곳</label>
            <div class="custom-select opt-color">
              <select class="select" v-model="returnPlaceCode">
                <option value="">전체</option>
                <option value="LOCAL">로컬</option>
                <option value="D507">안성</option>
                <option value="D510">서울</option>
              </select>
            </div>
          </div>
          <div class="cell">
            <label>반품 요청자</label>
            <div class="form-group mt10">
              <input type="text" class="input-text w100-p" placeholder="반품 요청자"
                  @keyup.enter="searchBtn"
                  v-model="returnRequestUserName">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="cell">
            <label for="">주문처</label>
            <div class="form-group mt10">
              <input type="text" class="input-text w100-p" placeholder="대리점"
                  @keyup.enter="searchBtn"
                  v-model="orderPartnerName">
            </div>
          </div>
          <div class="cell">
            <label for="">배송처</label>
            <div class="form-group mt10">
              <input type="text" class="input-text w100-p" placeholder="배송처"
                  @keyup.enter="searchBtn"
                  v-model="customerName">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="cell">
            <div class="custom-select opt-color" style="background-color: transparent; border: 0px;">
              <select class="select" v-model="dateTypeCode">
                <option value="OD">주문일자</option>
                <option value="RD">반품요청일</option>
              </select>
            </div>
						<inputDate id="stDate" v-model="stDate"/>
          </div>
          <div class="cell loc_edDate">
            <label for="" style="height:19px;"></label>
						<inputDate id="edDate" v-model="edDate"/>
          </div>
        </div>
      </div>
		</div>
    <div class="sub_sh_btn_wrap">
      <button class="sh_btn" @click="searchBtn">조회</button>
    </div>
		<div class="sub_contents">
      <div class="sub_contents_wrap">
        <h1>컨텐츠</h1>
        <div class="board_list_top mb5">
          <div class="sub_left_wrap w100-p">
            <!-- <div class="destxt bgWhite">주문취소 결과 : <span>주문번호</span>의 항목값을 누르면, 상세내역을 볼 수 있습니다.</div> -->
            <div class="destxt mt10">조회결과<span> {{listTotCnt}} </span>건</div>
          </div>
        </div>
        <div class="board_list type03 tbl_box">
          <table class="board_table" style="table-layout:fixed; width:1295px;">
            <caption class="hide">조회 테이블</caption>
            <colgroup>
              <col style="width:100px;">
              <col style="width:60px;">
              <col style="width:100px;">
              <col style="width:60px;">
              <col style="width:65px;">
              <col style="width:100px;">
              <col style="width:55px;">
              <col style="width:55px;">
              <col style="width:70px;">
              <col style="width:45px;">
              <col style="width:100px;">
              <col style="width:100px;">
              <col style="width:75px;">
              <col style="width:65px;">
              <col style="width:75px;">
              <col style="width:70px;">
              <col style="width:100px;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">주문번호</th>
                <th scope="col">구분</th>
                <th scope="col">대리점명</th>
                <th scope="col">주문일자</th>
                <th scope="col">반품요청일자</th>
                <th scope="col">요청자</th>
                <th scope="col">반품진행</th>
                <th scope="col">반품상태</th>
                <th scope="col">패널티금액</th>
                <th scope="col">반품품목</th>
                <th scope="col">상품코드</th>
                <th scope="col">상품명</th>
                <th scope="col">주문단가</th>
                <th scope="col">반품수량</th>
                <th scope="col">반품금액</th>
                <th scope="col">반품받을곳</th>
                <th scope="col">PENALTY</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in dataList" v-bind:key="index">
                <td scope="col">{{data.orderId}}</td>
                <td scope="col">{{data.orderClassName}}</td>
                <td class="tal" scope="col">{{data.orderPartnerName}}</td>
                <td scope="col">{{data.orderDate}}</td>
                <td scope="col">{{data.returnDate}}</td>
                <td class="tal" scope="col">{{data.chargeUserName}}</td>
                <td :style="{color: checkStatusStyle(data.returnStatusCode)}" scope="col">{{checkStatus(data.returnStatusCode)}}</td>
                <td scope="col">{{data.returnTypeName}}</td>
                <td class="tar" scope="col">{{Utils.numberComma(data.panaltyPrice)}}</td>
                <td class="tar" scope="col">{{Utils.numberComma(data.returnCount)}}</td>
                <td class="tal" scope="col">{{data.brandProductId}}</td>
                <td class="tal" scope="col">{{data.productName}}</td>
                <td class="tar" scope="col">{{Utils.numberComma(data.unitPrice)}}</td>
                <td class="tar" scope="col">{{Utils.numberComma(data.returnAmount)}}</td>
                <td class="tar" scope="col">{{Utils.numberComma(data.returnPrice)}}</td>
                <td scope="col">{{data.returnPlace}}</td>
                <td scope="col">{{data.penaltySopId}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="local_sum_wrap">
          <div class="sum_text">
            <span class="sumFont01">반품 조회결과 총 금액</span>
            <span class="sumFont02">{{totalPriceForm}}</span>
            <span class="sumFont03">원</span>
            <span class="sumFont04">VAT별도</span>
          </div>
        </div>
        <div class="board_list_bottom">
          <div class="sub_center_wrap">
            <div class="btn_area pt0">
              <!-- <a class="button dark"><span>일괄 승인</span></a> -->
            </div>
          </div>
        </div>
			</div>
    </div>
	</section>
</template>

<script>
import Vue from 'vue'
import router from '@/router'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import Grid from '@/components/Grid'
import GridModule from '@/modules/grid'
import InputDate from '@/components/InputDate'

export default {
  name: 'returningStatus',
	components: { Grid, InputDate },
	data () {
		return {
      AppConfig,
      Utils,
      listTotCnt: 0,
      dataList: [],
      totalPriceRaw: 0,
      totalPriceForm: '',
      gubnNomal: true,
      gubnInsurance: false,
      returnPlaceCode: '',
      returnProgressNomal: true,
      returnProgressInsurance: false,
      returnStatusRequest: true,
      returnStatusConfirm: false,
      returnStatusRejection: false,
      dateTypeCode: 'RD',
      stDate: '',
      edDate: '',
      returnRequestUserName: '',
      orderPartnerName: '',
      customerName: '',
      orderId: ''
		}
	},
	methods: {
		clkGubn(clsf) {
      switch (clsf) {
        case 'gubn_nomal': // 구분 일반
          this.gubnNomal = this.trueToFalse(this.gubnNomal);
          break;
        case 'gubn_insurance':  // 구분 보험
          this.gubnInsurance = this.trueToFalse(this.gubnInsurance);
          break;
        case 'return_progress_nomal': // 반품 진행 일반
          this.returnProgressNomal = this.trueToFalse(this.returnProgressNomal);
          break;
        case 'return_progress_insurance': // 반품 진행 보험
          this.returnProgressInsurance = this.trueToFalse(this.returnProgressInsurance);
          break;
        case 'return_status_request': // 반품 상태 요청
          this.returnStatusRequest = this.trueToFalse(this.returnStatusRequest);
          break;
        case 'return_status_confirm': // 반품 상태 승인
          this.returnStatusConfirm = this.trueToFalse(this.returnStatusConfirm);
          break;
        case 'return_status_rejection': // 반품 상태 반려
          this.returnStatusRejection = this.trueToFalse(this.returnStatusRejection);
          break;
        case 'all': // 전체
          this.gubnNomal = true;
          this.gubnInsurance = true;
          this.returnProgressNomal = true;
          this.returnProgressInsurance = true;
          this.returnStatusRequest = true;
          this.returnStatusConfirm = true;
          this.returnStatusRejection = true;
          break;
      }
    },
    trueToFalse(bol) {
      if (bol) {
        return false;
      }
      return true;
    },
    setRightCalendarStyle() {// 우측 카렌다 스타일 지정
      var month_calendar = $('.loc_edDate')[0].childNodes[2].childNodes[0].childNodes[0].childNodes[0].childNodes[2];
      var year_calendar = $('.loc_edDate')[0].childNodes[2].childNodes[0].childNodes[0].childNodes[0].childNodes[4];
      var decade_year_calendar = $('.loc_edDate')[0].childNodes[2].childNodes[0].childNodes[0].childNodes[0].childNodes[6];
      
			$(month_calendar).css('left', '-123px');
			$(year_calendar).css('left', '-123px');
			$(decade_year_calendar).css('left', '-123px');
    },
    setSrchParamInit() { // 검색 조건값 초기화
      this.clkGubn('all');
      this.stDate = Utils.getDate(1);
      this.edDate = Utils.getToday();
    },
    searchBtn() { // 조회버튼 클릭시
      const searchUrl = '/order/return/status/search';
      let params = {
        orderClassCode: [],
        returnStatusCode: [],
        returnTypeCode: [],
        returnPlaceCode: this.returnPlaceCode,
        returnRequestUserName: this.returnRequestUserName,
        orderPartnerName: this.orderPartnerName,
        dateTypeCode: this.dateTypeCode,
        startDate: this.stDate,
        endDate: this.edDate,
        customerName: this.customerName,
        orderId: this.orderId
      }

      if (this.gubnNomal == true) {
        params.orderClassCode.push('1');
      }
      if (this.gubnInsurance == true) {
        params.orderClassCode.push('2');
      }
      if (this.returnProgressNomal == true) {
        params.returnStatusCode.push('10');
      }
      if (this.returnProgressInsurance == true) {
        params.returnStatusCode.push('20');
      }
      if (this.returnStatusRequest == true) {
        params.returnStatusCode.push('30');
      }
      if (this.returnStatusConfirm == true) {
        params.returnTypeCode.push('10');
      }
      if (this.returnStatusRejection == true) {
        params.returnTypeCode.push('20');
      }

      this.dataList = [];
      this.listTotCnt = 0;
      this.totalPriceRaw = 0;

      Utils.showLoading('loading_grid_resultList');

      Vue.httpClient
        .post(searchUrl, params)
        .then(response => {
          if (response.data.result) {
            this.dataList = response.data.result;
            this.listTotCnt = this.dataList.length;

            for (let i in this.dataList) {
              this.totalPriceRaw += this.dataList[i].returnPrice * 1;
            }

            this.totalPriceForm = Utils.numberComma(this.totalPriceRaw);
          }
        })
				.finally(_ => {
					Utils.hideLoading('loading_grid_resultList');
				});
    },
    checkStatus(value) {
      if(value == "10") return "요청";
      else if(value == "20") return "승인";
      else if(value == "90") return "반려";
    },
    checkStatusStyle(value) {
      if(value == "10") return 'black';
      else if(value == "20") return 'blue';
      else if(value == "90") return 'red';
    }
	},
	mounted() {
		this.$nextTick(function() {
			var $this = this;
      this.setRightCalendarStyle(); // 우측 카렌다 스타일 지정
      this.setSrchParamInit(); // 검색 조건값 초기화
      this.searchBtn(); // 초기조회
		});
	},
	computed: {
    
	},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/returning/ReturningStatus.vue